/**
 * Конфигурация для работы с ramblerId
 */
const config = {
  // Имя проекта
  rname: 'afishaDaily',
  // Ссылка для логина в ramblerID
  redirectTo: '/login-20/login',
  // Названия тем для форм
  themeNames: {
    desktop: 'afisha-daily',
    mobile: 'afisha-daily-mobile'
  },
  // Названия ключей в localStorage
  keys: {
    /**
     * Посмотреть какое значение будет принимать этот ключ
     */
    FORCE_RID: 'forceRid',

    /**
     * Ключ для хранения RSIDX токена пользователя в LocalStorage
     * @type {string}
     */
    USER_KEY: 'dailyAuthUserToken',
    /**
     * Ключ для хранения ViewModel пользователя
     */
    USER_DATA_KEY: 'dailyAuthUserViewModel'
  },
  /**
   * Значение для Prime
   */
  referrer: 'https://daily.afisha.com'
};

export default config;



// WEBPACK FOOTER //
// ./daily/assets/id/config.js